import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PppCategory, PppType } from "@/types";
import { Layers, Search, Tag, X } from "lucide-react";
import { PPP_CATEGORIES, PPP_CATEGORY_LABEL, PPP_TYPE_LABEL, PPP_TYPES } from "./ppp-constants";

interface PppFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  type: PppType | "";
  onTypeChange: (v: PppType | "") => void;
  category: PppCategory | "";
  onCategoryChange: (v: PppCategory | "") => void;
}

const ALL = "all";

export function PppFilters({ search, onSearchChange, type, onTypeChange, category, onCategoryChange }: PppFiltersProps) {
  const hasAny = !!(search || type || category);

  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
      <div className="relative w-full sm:w-64">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Search PPPs…" value={search} onChange={(e) => onSearchChange(e.target.value)} className="pl-9" />
      </div>

      <Select value={type || ALL} onValueChange={(v) => onTypeChange(v === ALL ? "" : (v as PppType))}>
        <SelectTrigger className="w-[140px] gap-1.5"><Layers className="h-3.5 w-3.5" /><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>All types</SelectItem>
          {PPP_TYPES.map((t) => <SelectItem key={t} value={t}>{PPP_TYPE_LABEL[t]}</SelectItem>)}
        </SelectContent>
      </Select>

      <Select value={category || ALL} onValueChange={(v) => onCategoryChange(v === ALL ? "" : (v as PppCategory))}>
        <SelectTrigger className="w-[150px] gap-1.5"><Tag className="h-3.5 w-3.5" /><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>All categories</SelectItem>
          {PPP_CATEGORIES.map((c) => <SelectItem key={c} value={c}>{PPP_CATEGORY_LABEL[c]}</SelectItem>)}
        </SelectContent>
      </Select>

      {hasAny && (
        <Button variant="ghost" size="sm" className="gap-1 text-muted-foreground" onClick={() => { onSearchChange(""); onTypeChange(""); onCategoryChange(""); }}>
          <X className="h-3 w-3" /> Clear
        </Button>
      )}
    </div>
  );
}
